import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Summary element, used to wrap summaryitem elements (max 4)
 *
 * @slot buttons - used to place buttons (e.g. read more)
 * @slot - optional, used to wrap any other content
 *
 * @prop title - optional, used to set the titel of the slideritem (text)
 * @prop content - optional, used to set the content of the slideritem (text)
 *
 */
let SDBContentSliderItem = class SDBContentSliderItem extends LitElement {
    constructor() {
        super(...arguments);
        this.title = '';
        this.content = '';
    }
    render() {
        return html `
            <p class="title">${this.title}</p>
            <p class="content">${this.content}</p>
            <div class="buttonBar">
                <slot name="buttons"></slot>
            </div>
        `;
    }
};
SDBContentSliderItem.styles = [
    elements,
    css `
            @charset "UTF-8";

            :host {
                width: calc(100% - 40px);
                padding: 15px 20px;
                position: relative;
                background: white;
                min-height: 200px;
                max-height: 250px;
            }
            p {
                color: var(--text-primary);
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
            }

            p.title {
                -webkit-line-clamp: 2;
                font-weight: 400;
                min-height: 20px;
                max-height: 40px;
            }

            p.content {
                font-weight: 300;
                max-height: 65px;
                -webkit-line-clamp: 3;
            }

            div.buttonBar {
                display: block;
                position: relative;
                height: 55px;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBContentSliderItem.prototype, "title", void 0);
__decorate([
    property({ type: String })
], SDBContentSliderItem.prototype, "content", void 0);
SDBContentSliderItem = __decorate([
    customElement('sdb-content-slideritem')
], SDBContentSliderItem);
export { SDBContentSliderItem };
//# sourceMappingURL=sdb-content-slideritem.js.map